export default "__VITE_ASSET__DtjnQBr$__"